/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type { BodyType, ErrorType } from '../../axios';
import { request } from '../../axios';
import type { CreateMedicationDto, GetMedicationParams, MedicationDto, SetMedicationStatusParams } from '.././model';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

export const setMedicationStatus = (
  id: string,
  params: SetMedicationStatusParams,
  options?: SecondParameter<typeof request>,
) => {
  return request<void>({ url: `/api/medication/${id}/status`, method: 'PUT', params }, options);
};

export const getSetMedicationStatusMutationOptions = <
  TData = Awaited<ReturnType<typeof setMedicationStatus>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; params: SetMedicationStatusParams }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['setMedicationStatus'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setMedicationStatus>>,
    { id: string; params: SetMedicationStatusParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return setMedicationStatus(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; params: SetMedicationStatusParams },
    TContext
  >;
};

export type SetMedicationStatusMutationResult = NonNullable<Awaited<ReturnType<typeof setMedicationStatus>>>;

export type SetMedicationStatusMutationError = ErrorType<unknown>;

export const useSetMedicationStatus = <
  TData = Awaited<ReturnType<typeof setMedicationStatus>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; params: SetMedicationStatusParams }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; params: SetMedicationStatusParams }, TContext> => {
  const mutationOptions = getSetMedicationStatusMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getMedication = (
  params?: GetMedicationParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<MedicationDto[]>({ url: `/api/medication`, method: 'GET', params, signal }, options);
};

export const getGetMedicationQueryKey = (params?: GetMedicationParams) => {
  return [`/api/medication`, ...(params ? [params] : [])] as const;
};

export const getGetMedicationQueryOptions = <
  TData = Awaited<ReturnType<typeof getMedication>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMedicationParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedication>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMedicationQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedication>>> = ({ signal }) =>
    getMedication(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMedication>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMedicationQueryResult = NonNullable<Awaited<ReturnType<typeof getMedication>>>;
export type GetMedicationQueryError = ErrorType<unknown>;

export function useGetMedication<TData = Awaited<ReturnType<typeof getMedication>>, TError = ErrorType<unknown>>(
  params: undefined | GetMedicationParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedication>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getMedication>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedication<TData = Awaited<ReturnType<typeof getMedication>>, TError = ErrorType<unknown>>(
  params?: GetMedicationParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedication>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getMedication>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedication<TData = Awaited<ReturnType<typeof getMedication>>, TError = ErrorType<unknown>>(
  params?: GetMedicationParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedication>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMedication<TData = Awaited<ReturnType<typeof getMedication>>, TError = ErrorType<unknown>>(
  params?: GetMedicationParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedication>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMedicationQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMedicationSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMedication>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMedicationParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedication>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMedicationQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedication>>> = ({ signal }) =>
    getMedication(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMedication>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMedicationSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMedication>>>;
export type GetMedicationSuspenseQueryError = ErrorType<unknown>;

export function useGetMedicationSuspense<
  TData = Awaited<ReturnType<typeof getMedication>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetMedicationParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedication>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedicationSuspense<
  TData = Awaited<ReturnType<typeof getMedication>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMedicationParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedication>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedicationSuspense<
  TData = Awaited<ReturnType<typeof getMedication>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMedicationParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedication>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMedicationSuspense<
  TData = Awaited<ReturnType<typeof getMedication>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMedicationParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedication>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMedicationSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createMedication = (
  createMedicationDto: BodyType<CreateMedicationDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>(
    {
      url: `/api/medication`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createMedicationDto,
      signal,
    },
    options,
  );
};

export const getCreateMedicationMutationOptions = <
  TData = Awaited<ReturnType<typeof createMedication>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreateMedicationDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createMedication'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMedication>>,
    { data: BodyType<CreateMedicationDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createMedication(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: BodyType<CreateMedicationDto> },
    TContext
  >;
};

export type CreateMedicationMutationResult = NonNullable<Awaited<ReturnType<typeof createMedication>>>;
export type CreateMedicationMutationBody = BodyType<CreateMedicationDto>;
export type CreateMedicationMutationError = ErrorType<unknown>;

export const useCreateMedication = <
  TData = Awaited<ReturnType<typeof createMedication>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreateMedicationDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { data: BodyType<CreateMedicationDto> }, TContext> => {
  const mutationOptions = getCreateMedicationMutationOptions(options);

  return useMutation(mutationOptions);
};
